import React from "react";

export const ArrowForward = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
  <g fill="none" fillRule="evenodd" transform="translate(-4 -4)">
    <polygon points="0 0 24 0 24 24 0 24"/>
    <path d="M5,13 L16.17,13 L11.29,17.88 C10.9,18.27 10.9,18.91 11.29,19.3 C11.68,19.69 12.31,19.69 12.7,19.3 L19.29,12.71 C19.68,12.32 19.68,11.69 19.29,11.3 L12.71,4.7 C12.32,4.31 11.69,4.31 11.3,4.7 C10.91,5.09 10.91,5.72 11.3,6.11 L16.17,11 L5,11 C4.45,11 4,11.45 4,12 C4,12.55 4.45,13 5,13 Z"/>
  </g>
</svg>
)